module.exports = __webpack_public_path__ + "static/may-1-56680c9825bd89dccec1236ca037c4d6.png";